// Sportera - Onglets produit (section indépendante, desktop uniquement)
// Fichier : assets/sportera-product-tabs.js
(function () {
  function initSporteraProductTabs(root) {
    var tabs = Array.prototype.slice.call(
      root.querySelectorAll('.sportera-product-tabs__tab')
    );
    var panels = Array.prototype.slice.call(
      root.querySelectorAll('.sportera-product-tabs__panel')
    );

    if (!tabs.length || !panels.length) return;

    function activate(targetKey, focusTab) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-tab-target') === targetKey;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
        if (isActive && focusTab) tab.focus();
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-tab-panel') === targetKey;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-tab-target'), false);
      });

      tab.addEventListener('keydown', function (event) {
        var newIndex = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          newIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          newIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          newIndex = 0;
        } else if (event.key === 'End') {
          newIndex = tabs.length - 1;
        }

        if (newIndex !== null) {
          event.preventDefault();
          activate(tabs[newIndex].getAttribute('data-tab-target'), true);
        }
      });
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-sportera-product-tabs]');
    Array.prototype.forEach.call(roots, function (root) {
      initSporteraProductTabs(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
